export default __webpack_public_path__ + "locales/en/RoomLogoCover.json?hash=81cc65d07df7465dce7198ab214fc3b9";